import React, { useCallback } from 'react';

// INTERFACES
import { IButtonProps } from '../../interfaces/Button.interface';

//Constants
import { sideButton } from '../../enums/sideButton';

// STYLES
import { ButtonStyled, Content } from './styles';

const Button: React.FC<IButtonProps> = ({
  children,
  disabled,
  onClick,
  icon: Icon,
  sideIcon = sideButton.NONE,
  id,
  ...restProps
}: IButtonProps) => {
  const handleClick = useCallback(
    (e: any) => {
      if (!disabled) {
        onClick(e);
      }
    },
    [onClick, disabled]
  );
  return (
    <ButtonStyled id={id} type="button" sideIcon={sideIcon} disabled={disabled} onClick={handleClick} {...restProps}>
      <Content sideIcon={sideIcon} {...restProps}>
        {Icon && sideIcon != 'none' && <Icon />}
        {sideIcon != 'center' && <span>{children}</span>}
      </Content>
    </ButtonStyled>
  );
};

export default Button;
